import React from 'react';
import { DayOfWeek, DayFilter } from './subparts/types';

const daysOfWeek: DayOfWeek[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// "All" first, then the individual days
const chipOptions: DayFilter[] = ['All', ...daysOfWeek];

interface DayChipsProps {
  selectedDay: DayFilter;
  onSelect: (day: DayFilter) => void;
}

const DayChips: React.FC<DayChipsProps> = ({ selectedDay, onSelect }) => {
  return (
    <>
      <style>{`
        .day-chip {
          padding: 8px 16px;
          border: 1.5px solid #e5e7eb;
          border-radius: 8px;
          background: white;
          color: #1f2937;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          outline: none;
          transition: all 0.2s ease;
        }
        .day-chip.selected {
          border-color: #10b981;
          background: linear-gradient(135deg, #059669 0%, #10b981 50%, #34d399 100%);
          color: white;
          box-shadow: 0 2px 8px rgba(16, 185, 129, 0.25);
        }
        .day-chip:hover:not(.selected) {
          background: #ecfdf5;
          transform: translateY(-1px);
        }
        .day-chip-all:not(.selected) {
          border-color: #a7f3d0;
          color: #047857;
        }
      `}</style>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
        {chipOptions.map((day) => (
          <button
            key={day}
            onClick={() => onSelect(day)}
            className={`day-chip${day === 'All' ? ' day-chip-all' : ''}${selectedDay === day ? ' selected' : ''}`}
          >
            {day === 'All' ? (
              <>
                <i className="pi pi-calendar" style={{ fontSize: 12, marginRight: 6 }} />
                All
              </>
            ) : (
              day
            )}
          </button>
        ))}
      </div>
    </>
  );
};

export default DayChips;